import { createSlice } from '@reduxjs/toolkit';
import { _setUnViewed } from './userExperienceAction';
import { initialState } from './userExperienceInitialState';

const userExperienceSlice = createSlice({
  name: 'delta/userinks',
  initialState: initialState,
  reducers: {
    setUnViewed: _setUnViewed,
    resetUserLists: () => initialState,
  },
});

export const { setUnViewed, resetUserLists } = userExperienceSlice.actions;

export default userExperienceSlice.reducer;
